import request from '@/utils/request'

const purchaseApi = process.env.VUE_APP_PURCHASE_API
const BID_FILE_API = process.env.VUE_APP_BID_FILE_API

/**
 * 获取服务器时间的时间戳
 */
export function getSystemTimeApi() {
  return request(
    {
      url: purchaseApi + '/workbench/time',
      method: 'get'
    },
    false
  )
}

/**
 * 查询大厅门户信息
 */
export function getKbProjectInHallApi(projectId) {
  return request({
    url: purchaseApi + `/bid-hall/${projectId}`,
    method: 'get'
  })
}

/**
 * 查询开标项目详情
 */
export function getKbProjectDetailInHallApi(projectId) {
  return request(
    {
      url: purchaseApi + `/bid-hall/${projectId}/detail`,
      method: 'get'
    },
    false
  )
}

// 采购人端-----------------------
/**
 * 分页查询投标人
 * @param {number} projectId 开评标项目id
 * @param {Object} params 请求数据
 * @returns {Promise<void>|*}}
 */
export function getBidderListApi(projectId, params) {
  return request(
    {
      url:
        purchaseApi +
        `/bid-hall/purchaser/kpb/projects/${projectId}/bidders/page`,
      method: 'get',
      params
    },
    false
  )
}

/**
 * 查询投标人汇总信息
 */
export function getBidderSummaryApi(projectId) {
  return request(
    {
      url:
        purchaseApi +
        `/bid-hall/purchaser/kpb/projects/${projectId}/bidders/summary`,
      method: 'get'
    },
    false
  )
}

/**
 * 开启唱标（开标一览表）
 * @param {number} projectId 开评标项目id
 * @returns {Promise<void>|*}}
 */
export function openMarkApi(projectId) {
  return request({
    url:
      purchaseApi + `/bid-hall/purchaser/kpb/projects/${projectId}/open-mark`,
    method: 'post'
  })
}

/**
 * 分页查询投标人-唱标列表
 * @param {number} projectId 开评标项目id
 * @param {Object} params 请求数据
 * @returns {Promise<void>|*}}
 */
export function getMarkListApi(projectId, params) {
  return request(
    {
      url:
        purchaseApi +
        `/bid-hall/purchaser/kpb/projects/${projectId}/bidders/marks/page`,
      method: 'get',
      params
    },
    false
  )
}

// 查询所有投标人-开标一览表
export function getAllMarkListApi(projectId) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/purchaser/kpb/projects/${projectId}/bidders/marks`,
    method: 'get'
  })
}

/**
 * 退回投标文件
 * @param {number} projectId 开评标项目id
 * @param {number} bidderId 投标人id
 * @param {Object} data 请求数据
 * @returns {Promise<void>|*}}
 */
export function returnBidFileApi(projectId, bidderId, data) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/purchaser/kpb/projects/${projectId}/bidders/${bidderId}/file-back`,
    method: 'post',
    data
  })
}

/**
 * 添加现场备注
 * @param {number} projectId 开评标项目id
 * @param {number} bidderId 投标人id
 * @param {Object} data 请求数据
 * @returns {Promise<void>|*}
 */
export function addBidMarkApi(projectId, bidderId, data) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/purchaser/kpb/projects/${projectId}/bidders/${bidderId}/bid-remark`,
    method: 'post',
    data
  })
}

/**
 * 结束开标
 * @param {number} projectId 开评标项目id
 * @param {Object} data 请求数据
 * @returns {Promise<void>|*}
 */
export function endBidOpenApi(projectId, data) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/purchaser/kpb/projects/${projectId}/open-bid-end`,
    method: 'post',
    data
  })
}

/**
 * 获取投标人汇总信息
 * @param projectId
 * @returns {Promise<void>|*}
 */
export function getBidderTotalApi(projectId) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/purchaser/kpb/projects/${projectId}/bidders/summary`,
    method: 'get'
  })
}

// 文件解密 (需要轮询)，获取解密结果
export function getDecodeResultApi({ projectId, bidderId }, params) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/purchaser/kpb/projects/${projectId}/bidders/${bidderId}/file-decryption`,
    method: 'get',
    params
  })
}

// ------------------------ 开标大厅聊天室相关接口 ------------------------
// 聊天室-发送消息 （采购人）
export function sendMessageInChatroomApi(data, projectId) {
  return request(
    {
      url: `${purchaseApi}/bid-hall/purchaser/kpb/projects/${projectId}/chat/send`,
      method: 'post',
      data
    },
    false
  )
}

// 聊天室-查询聊天消息 （采购人）
export function getChatMessageInChatroomApi(params, projectId) {
  return request(
    {
      url: `${purchaseApi}/bid-hall/purchaser/kpb/projects/${projectId}/chat/messages/page`,
      method: 'get',
      params
    },
    false
  )
}

// 聊天室 - 获取消息统计（采购人）
export function getMessageStatisticalDataApi(params, projectId) {
  return request(
    {
      url: `${purchaseApi}/bid-hall/purchaser/kpb/projects/${projectId}/chat/messages/total`,
      method: 'get',
      params
    },
    false
  )
}

// 聊天室 - 设置消息已读（采购人）
export function setMessageReadInChatroomApi(data, projectId) {
  return request(
    {
      url: `${purchaseApi}/bid-hall/purchaser/kpb/projects/${projectId}/chat/messages/read`,
      method: 'post',
      data
    },
    false
  )
}

// 供应商端-------------------------------

// 文件解密结果
export function supplierDecodeApi({ projectId, bidderId }, params) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/supplier/kpb/projects/${projectId}/bidders/${bidderId}/file-decryption`,
    method: 'get',
    params
  })
}

/**
 * 查询自己的投标人的唱标信息
 * @param {number} projectId 开评标项目id
 * @param {number} bidderId 投标人id
 * @param {data} params 请求数据
 * @returns {Promise<void>|*}
 */
export function supplierGetMarkApi(projectId, bidderId, params) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/supplier/kpb/projects/${projectId}/bidders/${bidderId}/owner-info`,
    method: 'get',
    params
  })
}

/**
 * 分页查询投标人-唱标列表
 * @param {number} projectId 开评标项目id
 * @param {number} bidderId 投标人id
 * @param {data} params 请求数据
 * @returns {Promise<void>|*}
 */
export function supplierGetOtherMarkApi(projectId, bidderId, params) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/supplier/kpb/projects/${projectId}/bidders/${bidderId}/marks/page`,
    method: 'get',
    params
  })
}

/* *** 投标文件UKey解密相关接口 *** */
// 获取数字信封
export function getDigitalEnvelopeApi(encryptFileId, params) {
  return request({
    url: BID_FILE_API + `/bid-file/${encryptFileId}/digital-envelope`,
    method: 'get',
    params
  })
}

// 解密标书
export function decryptBidFileApi(encryptFileId, data) {
  return request({
    url: BID_FILE_API + `/bid-file/${encryptFileId}/decrypt`,
    method: 'post',
    data
  })
}

// 查询解密标书结果
export function getDecryptFileResultApi({ encryptFileId }, params) {
  return request({
    url: BID_FILE_API + `/bid-file/${encryptFileId}/decrypt/result`,
    method: 'get',
    params
  })
}

// 获取移动CA解密二维码
export function getDecryptQrCodeApi(encryptFileId, params) {
  return request({
    url: BID_FILE_API + `/bid-file/${encryptFileId}/decrypt/qr-code`,
    method: 'get',
    params
  })
}

// 获取移动CA解密二维码结果
export function getDecryptQrCodeResultApi(taskId) {
  return request(
    {
      url: BID_FILE_API + `/bid-file/decrypt/qr-code/${taskId}/result`,
      method: 'get'
    },
    false
  )
}

// 开标大厅在线供应商
export function getBiddersOnlineApi(projectId) {
  return request(
    {
      url:
        purchaseApi +
        `/bid-hall/purchaser/kpb/projects/${projectId}/bidders/online`,
      method: 'get'
    },
    false
  )
}

// 更新开标大厅供应商状态
export function supplierOnlineRefreshApi(projectId) {
  return request(
    {
      url:
        purchaseApi +
        `/bid-hall/supplier/kpb/projects/${projectId}/online-refresh`,
      method: 'get'
    },
    false
  )
}

// 获取唱标内容
export function getBiddersMarksApi(projectId) {
  return request(
    {
      url:
        purchaseApi +
        `/bid-hall/purchaser/kpb/projects/${projectId}/bidders/marks`,
      method: 'get'
    },
    false
  )
}

// ------------------------ 开标大厅聊天室相关接口 ------------------------
// 聊天室-发送消息 （供应商）
export function sendMessageInChatroomBySupplierApi(data, projectId, bidderId) {
  return request(
    {
      url: `${purchaseApi}/bid-hall/supplier/kpb/projects/${projectId}/bidders/${bidderId}/chat/send`,
      method: 'post',
      data
    },
    false
  )
}

// 聊天室-查询聊天消息 （供应商）
export function getChatMessageInChatroomBySupplierApi(
  params,
  projectId,
  bidderId
) {
  return request(
    {
      url: `${purchaseApi}/bid-hall/supplier/kpb/projects/${projectId}/bidders/${bidderId}/chat/messages/page`,
      method: 'get',
      params
    },
    false
  )
}

// 聊天室 - 获取消息统计（供应商）
export function getMessageStatisticalDataBySupplierApi(
  params,
  projectId,
  bidderId
) {
  return request(
    {
      url: `${purchaseApi}/bid-hall/supplier/kpb/projects/${projectId}/bidders/${bidderId}/chat/messages/total`,
      method: 'get',
      params
    },
    false
  )
}

// 聊天室 - 设置消息已读 （供应商）
export function setMessageReadInChatroomBySupplierApi(
  data,
  projectId,
  bidderId
) {
  return request(
    {
      url: `${purchaseApi}/bid-hall/supplier/kpb/projects/${projectId}/bidders/${bidderId}/chat/messages/read`,
      method: 'post',
      data
    },
    false
  )
}

// 提交控制价
export function submitKpbOpenControlPriceApi(projectId, data) {
  return request({
    url: purchaseApi + `/bid-hall/purchaser/kpb/projects/${projectId}/control-price/submit`,
    method: 'post',
    data
  })
}

// -------------------------------------------------------------------------双信封接口
// 开启商务报价文件解密
export function startBidOpenDecryptApi(projectId, data) {
  return request({
    url:
      purchaseApi +
      `/bid-hall/purchaser/kpb/projects/v2/${projectId}/business-open/start`,
    method: 'post',
    data
  })
}
